import { render, staticRenderFns } from "./ThemeSelectionDialog.vue?vue&type=template&id=5e96b174&scoped=true"
import script from "./ThemeSelectionDialog.vue?vue&type=script&lang=js"
export * from "./ThemeSelectionDialog.vue?vue&type=script&lang=js"
import style0 from "./ThemeSelectionDialog.vue?vue&type=style&index=0&id=5e96b174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e96b174",
  null
  
)

export default component.exports